var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{ref:"xTable",attrs:{"resizable":"","column-config":{ minWidth: '80px' },"data":_vm.tableData,"toolbar-config":_vm.tableToolbar,"size":"mini","mouse-config":{ area: true },"edit-rules":_vm.validRules,"highlight-hover-row":"","highlight-current-row":"","height":_vm.tableHeight,"columns":_vm.gridColumns,"edit-config":{
      trigger: 'dblclick',
      mode: 'cell',
      activeMethod: _vm.activeMethod
    },"keyboard-config":{
      isArrow: true,
      isEnter: true,
      isTab: true,
      enterToTab: true,
      isClip: true,
      isEdit: true,
      editMethod: _vm.editMethod
    }},on:{"toolbar-button-click":_vm.toolbarButtonClickEvent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }